import React, { FunctionComponent, memo, useRef } from 'react';
import './SortListTable.scss';
import { isEqual } from 'lodash';
import SortListBundle, { ISortListBundle } from './SortListBundle';

interface SortListTableProps {
  updateHubSortListEntries: (bundleIds: string[]) => Promise<void>;
  sortListBundles: ISortListBundle;
}

const checkProps = (
  prevProps: Readonly<SortListTableProps>,
  nextProps: Readonly<SortListTableProps>
) => isEqual(prevProps.sortListBundles, nextProps.sortListBundles);

const SortListTable: FunctionComponent<SortListTableProps> = memo(props => {
  const measureReference = useRef<HTMLDivElement>(null);
  const { sortListBundles, updateHubSortListEntries } = props;

  return (
    <div
      className="sort-list__page"
      key={sortListBundles?.id}
      ref={measureReference}
    >
      <SortListBundle
        bundleData={sortListBundles}
        updateHubSortListEntries={updateHubSortListEntries}
      />
    </div>
  );
}, checkProps);

SortListTable.displayName = 'SortListTable';
export { SortListTable };
